export default __webpack_public_path__ + "static/media/ic_pig.22177125.svg";